import '../ApplicationCard/applicationCard.scss';

import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import VehicleImagePlaceholder from '../../assets/vehicle-placeholder.png';
import { RefandiCardProps } from './types/RefandiCardProps';

export const RefandiCard = ({ testId }: RefandiCardProps): ReactNode => {
  const { t } = useTranslation();

  return (
    <li data-testid={testId}>
      <Link className="application-card" to={'/loan-documents'}>
        <figure>
          <img
            alt={t('DashboardGaragePage.refandi.description')}
            className="application-card-image"
            src={VehicleImagePlaceholder}
          />
        </figure>
        <div className="application-card-content">
          <p className="card-title">
            {t('DashboardGaragePage.refandi.description')}
          </p>
          <p className="card-subtitle">
            {t('DashboardGaragePage.refandi.applicationDescription')}
          </p>
        </div>
      </Link>
    </li>
  );
};
